import cashInOutActionTypes from "./cash-in-out-types";

export const getEmployees = (requestData) => ({
  type: cashInOutActionTypes.GET_EMPLOYEES_START,
  payload: requestData,
});

export const getReasonCodes = (requestData) => ({
  type: cashInOutActionTypes.GET_REASON_CODE_START,
  payload: requestData,
});

export const getWarehouses = (requestData) => ({
  type: cashInOutActionTypes.GET_WAREHOUSE_START,
  payload: requestData,
});

export const getPointOfSales = (requestData) => ({
  type: cashInOutActionTypes.GET_POINT_OF_SALE_START,
  payload: requestData,
});

export const getSessionUser = (requestData) => ({
  type: cashInOutActionTypes.GET_SESSION_USER_START,
  payload: requestData,
});

export const getStoreRegions = (requestData) => ({
  type: cashInOutActionTypes.GET_STORE_REGIONS_START,
  payload: requestData,
});
